import { useState } from 'react'
import { Link } from 'react-router-dom'

function Nav () {
  const [iconMenu, setIconMenu] = useState('menu')
  const changeMenuIcon = () => {
    iconMenu === 'menu' ? setIconMenu('close') : setIconMenu('menu')
  }
  return (
    <nav className='p-5 bg-white shadow flex items-center justify-between'>
      <div className='flex justify-between items-center' style={{ width: '100%' }}>
        <span className='text-xl sm:text-3xl font-bold cursor-pointer'>
          Liên Đoàn Trường Giang
        </span>
        <ul className={iconMenu === 'menu' ? 'items-center z-[-1] absolute bg-white w-full left-0 py-7 pl-7 opacity-0 top-[-400px] transition-all ease-in duration-500' : 'z-[-1] absolute bg-white w-full left-0 py-7 pl-7 opacity-100 top-[70px] transition-all ease-in duration-500'}>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>Home</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/bai' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>Bài Ca Hướng Đạo Việt Nam</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/quoc' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>Quốc Ca Việt Nam</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/us' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>US National Anthem</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/loi' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>10 Điều Luật Hướng Đạo</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/moi' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>Mừng Anh Mới Tới</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/anh' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>Anh Em Ta Về</Link>
          </li>
          <li className='mx-4 my-6 2xl:my-0 cursor-pointer'>
            <Link to='/vui' className='text-sm sm:text-base md:text-xl lg:text-2xl hover:text-cyan-500 duration-500' onClick={changeMenuIcon}>Lúc Thú Vui Này</Link>
          </li>
        </ul>
        <span className='material-symbols-outlined text-3xl cursor-pointer' onClick={changeMenuIcon}>
          {iconMenu}
        </span>
      </div>

    </nav>
  )
}

export default Nav
